export default __webpack_public_path__ + "static/media/QOS_BLACK-min.2198ceb4.webp";